import React from 'react';
import { Link } from 'react-router-dom';

function Footer({ bgColor }) {
	return (
		<div className={bgColor}>
			<div className="site-footer alt-color--dark">
				<Link className="site-link" to="/terms-of-use-and-privacy-policy">
					<span className="link-text--small">Privacy &amp; Terms</span>
					<span className="link-text--medium">Terms of Use &amp; Privacy Policy</span>
				</Link>

				<span className="alt-color--lighter">
					Made by <a className="site-link" href="https://twitter.com/lslez" target="_blank" rel="noopener noreferrer">@lslez</a>.
				</span>
			</div>
		</div>
	);
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Site/Footer.js